import {TechnicalConclusion} from "../types/technical-conclusion-types";

export const defaultTechnicalConclusionData: TechnicalConclusion = {
  id: 0,
  conclusionNumber: 'Новое',
  comment: ''
}
